import React from 'react'
import styles from './Icon.module.scss'

import FightbackLogo from '../../assets/images/fightback_logo.svg'
import FacebookIcon from '../../assets/images/facebook_icon.svg'
import InstagramIcon from '../../assets/images/instagram_icon.svg'
import YoutubeIcon from '../../assets/images/youtube_icon.svg'
import WhatsAppIcon from '../../assets/images/whatsapp_icon.svg'

export const FightbackLogoImage = (
  <img className={styles.buttonImage} src={FightbackLogo} alt='Fightback-Logo' />
)
export const NoCursorFightbackLogoImage = (
  <img className={styles.noCursorButtonImage} src={FightbackLogo} alt='Fightback-Logo' />
)

export const FacebookIconImage = (
  <img className={styles.buttonImage} src={FacebookIcon} alt='Facebook-Icon' />
)

export const InstagramIconImage = (
  <img className={styles.buttonImage} src={InstagramIcon} alt='Instagram-Icon' />
)

export const YoutubeIconImage = (
  <img className={styles.buttonImage} src={YoutubeIcon} alt='YouTube-Icon' />
)

export const WhatsAppIconImage = (
  <img className={styles.buttonImage} src={WhatsAppIcon} alt='YouTube-Icon' />
)
